import { Tabs, Tab } from "@mui/material";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import { BRAND_COLOR } from "../constants";

interface LeadsStatusTabsProps {
  data: LeadsManagementData;
}

const STATUS_TAB_TRACKER_IDS: Record<string, string> = {
  Pending: "1028",
  Initial: "1029",
  Success: "1030",
  Failure: "1031",
  InternalDuplication: "1032",
  BrandDuplication: "1033",
  Not_Supported: "1034",
  Rejected: "979",
};

export default function LeadsStatusTabs({ data }: LeadsStatusTabsProps) {
  const { status, statusTabs, setStatus, isLoading } = data;

  return (
    <Tabs
      value={status}
      onChange={(_, value) => setStatus(value)}
      variant="scrollable"
      scrollButtons={false}
      sx={{
        mt: 2.75,
        borderBottom: "1px solid #e6e6e6",
        minHeight: 0,
        "& .MuiTab-root": {
          minHeight: 0,
          fontSize: 13.5,
          fontWeight: 500,
          letterSpacing: "0.5px",
          color: "#6b6b6b",
        },
        "& .Mui-selected": { color: `${BRAND_COLOR} !important` },
        "& .MuiTabs-indicator": { backgroundColor: BRAND_COLOR, height: 3 },
      }}
    >
      <Tab value="All" label="ALL" disabled={isLoading} data-tracker="1027" />
      {statusTabs.map((tab) => (
        <Tab
          key={tab.key}
          value={tab.key}
          label={tab.label.toUpperCase()}
          disabled={isLoading}
          data-tracker={STATUS_TAB_TRACKER_IDS[tab.key]}
        />
      ))}
    </Tabs>
  );
}
